module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1125.59a25129.png";